import { DataLayerEvent, DecisionsDisplayedEvent, PageLoadedEvent, ProductLoadedEvent } from "@/events";
import merge from 'deepmerge';

export class AdobeDataLayerService {
  private static _dataLayer: { [key: string]: DataLayerEvent } = {};
  static {
    window.adobeDataLayer = window.adobeDataLayer || [];
  }

  private static combineMerge(target: unknown[], source: unknown[]) {
    const mergeResult = new Set<string>();

    if (source.length) {
      source.forEach(sourceElement => {
        mergeResult.add(JSON.stringify(sourceElement));
      });
    }

    if (target.length) {
      target.forEach(targetElement => {
        mergeResult.add(JSON.stringify(targetElement));
      });
    }

    return [...mergeResult].map(value => JSON.parse(value))
  }

  /**
   * add the values from the local object to adobeDataLayer
   */
  private static pushEventsToDataLayer() {
    const productLoadedObject = (this._dataLayer['product loaded'] || this._dataLayer['campaign product']) as ProductLoadedEvent;
    if (productLoadedObject) {
      const productObject = productLoadedObject['product'];
      productObject.all = productObject.all?.filter(product =>
        !productObject.info?.some(mainProduct => JSON.stringify(product) === JSON.stringify(mainProduct))
      );

      Object.keys(productObject).forEach(key => {
        if (!productObject[key] || !productObject[key].length) {
          delete productObject[key];
        }
      });
    }

    Object.keys(this._dataLayer).forEach(dataLayerKey => {
      window.adobeDataLayer.push({ ...this._dataLayer[dataLayerKey] });
      delete this._dataLayer[dataLayerKey];
    });
  }

  // getter for funcionality checks
  public static get dataLayer() {
    return this._dataLayer;
  }

  public static push(event: DataLayerEvent) {

    /**
     * keep adding values to the already existing event
     */
    if (event instanceof ProductLoadedEvent || event instanceof DecisionsDisplayedEvent) {
      /**
       * start constructing an object for the local _dataLayer where the event name is the key
       * Example: {
       *  "product loaded": new ProductsLoadedEvent
       * }
       */
      const eventObject = {
        [event.event]: event
      };
      this._dataLayer = merge(this._dataLayer, eventObject, { arrayMerge: this.combineMerge });

      return;
    } else if (event instanceof PageLoadedEvent) {
      this.pushEventsToDataLayer();
    }

    window.adobeDataLayer.push({ ...event });
  }
}